export default "/assets/images/gottcha-hero.png?219951150e4c0ebd90cd797e66cec80a";